import { UserToken } from '../../app/modules/chart/interface/interfaces';
import { ReduxAction, ReduxType } from '../interface';

const data: UserToken = {
  authToken: '',
  baseUrl: '',
  firmId: '',
  firmName: '',
  serviceName: '',
  userId: ''
};
export default (state: UserToken, action: ReduxAction<UserToken>) => {
  if (!state) {
    state = data;
  }
  switch (action.type) {
    case ReduxType.GET_TOKEN:
      return Object.assign({}, state, action.payload);
    case ReduxType.USER_DEFAULT:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
};
